import { NavigableButton } from '@carvana/ds-button';
import OilCheck from '@carvana/ds-icons/OilCheckSpot';
import Service from '@carvana/ds-icons/ServiceSpot';
import { testDriveCenterImages } from '~/constants/dealership/testDriveCenter/assets';
import optimizeImage from '~/utilities/optimizeImage';

const section = 'Test Drive Center - Service';

function IconChip({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex items-center rounded-2xl border border-border-subtle bg-white p-xl shadow-xl">
      {children}
    </div>
  );
}

export default function TestDriveCenterService() {
  return (
    <div className="bg-canvas-default px-2xl py-6xl md:px-3xl md:py-7xl lg:px-4xl">
      <div className="mx-auto flex max-w-[1272px] flex-col items-center justify-between gap-4xl md:flex-row-reverse lg:gap-9xl">
        <div className="relative md:w-1/2">
          <img
            src={optimizeImage(testDriveCenterImages.expertService, {
              crop: '3:2',
              format: 'auto',
              optimize: 'medium'
            })}
            alt="A technician inspecting a truck on a lift"
            width={516}
            height={344}
            className="w-full rounded-xl object-cover"
            loading="lazy"
          />
          <div className="absolute left-[-16px] top-[40px] md:left-[-44px]">
            <IconChip>
              <Service size={56} />
            </IconChip>
          </div>
          <div className="absolute bottom-[40px] right-[-16px] md:right-[-44px]">
            <IconChip>
              <OilCheck size={56} />
            </IconChip>
          </div>
        </div>

        <div className="flex flex-col gap-y-2xl md:w-1/2">
          <div className="flex flex-col gap-y-lg">
            <h2 className="text-text-strong t-heading-xl md:t-heading-2xl">
              Expert auto service
            </h2>
            <p className="text-text-default t-body-md">
              Oil changes, brakes, or something bigger — our factory-trained
              techs fix what’s needed and skip what isn’t. Up-front pricing, no
              surprises.
            </p>
          </div>

          <NavigableButton
            size="md"
            variant="primary"
            width="fit-content"
            href="/service"
            data-adobe-id="book-now"
            data-analytics-id={`${section} - Book Now`}
            data-testid="test-drive-center-book-now"
          >
            Book Now
          </NavigableButton>
        </div>
      </div>
    </div>
  );
}
